<template>
    <v-layout ref="app" class="column w-100 h-100 owner-actions-layout">
        <div class="header w-100">
            <v-container fluid class="px-8">
                <div v-if="hasTitle" class="d-flex title-container">
                    <v-img
                        src="/images/OnflyLogo.png"
                        width="120px"
                    />
                    <div class="w-100 text-center py-2">
                        <span class="page-title color-grey-onfly">{{ pageTitle }}</span>
                        <div v-if="hasSubtitle" class="page-subtitle color-grey-onfly">
                            {{ subtitle }}
                        </div>
                    </div>
                </div>
                <div v-else class="d-flex title-container justify-center">
                    <span class="img-container">
                        <v-img
                            src="/images/OnflyLogo.png"
                            width="120px"
                        />
                    </span>
                </div>
            </v-container>
        </div>
        <v-main>
            <router-view/>
        </v-main>
        <div class="footer">
        </div>
    </v-layout>
</template>
<script>
export default {
    name: "HotelOwnerActionsLayout",
    data() { return {
        subtitle: null,
    }},
    computed: {
        pageTitle () {
            return this.$route.meta.title;
        },
        hasSubtitle () {
            return this.subtitle !== null && this.subtitle !== '';
        },
        hasTitle () {
            const title = this.$route.meta.title;
            return title !== null && title !== '';
        }
    },
    mounted() {
        this.$root.$on('set-layout-subtitle', (subtitle) => {
            this.subtitle = subtitle;
        })
    },
    beforeDestroy() {
        this.$root.$off('set-layout-subtitle');
    }
}
</script>
<style lang="scss" scoped>
:global(.v-application.v-application--is-ltr.theme--light) {
    background-color: #F5F5F6 !important;
}
.bg-blue-onfly {
    background: #009efb !important;
}

.border-blue-onfly {
    border-color: #009efb !important;
}

.bg-blue-onfly-darker {
    background: #007dc7 !important;
}

.color-blue-onfly {
    color: #009efb !important;
}

.color-blue-onfly-darker {
    color: #007dc7 !important;
}

.text-white-50 {
    color: #f7f7f9 !important;
}

.color-grey-onfly {
    color: #54667a !important;
}

.page-title,
.page-subtitle {
    font-weight: bold;
    text-transform: uppercase;
}
.page-title {
    font-size: 24px;
}
.page-subtitle {
    font-size: 18px;
}
:deep(.v-image__image--cover) {
    background-size: contain;
}

.owner-actions-layout {
    max-width: 1440px;
    margin: 0 auto;
    padding-top: 0.75rem;
}

@media screen and (max-width: 960px) {
    .title-container {
        flex-direction: column;

        .img-container {
            max-width: 120px !important;
        }

        .v-image {
            margin: 0.75rem auto;
        }
    }
}
</style>
